import React from 'react';
import './AboutUsPageManifesto.scss';
import TextSnippetRoundedIcon from '@mui/icons-material/TextSnippetRounded';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import LightbulbRoundedIcon from '@mui/icons-material/LightbulbRounded';

const AboutUsPageManifesto = () => {
  return (
    <section className="manifesto-section">
      <div className="manifesto-container">
        {/* Header */}
        <div className="manifesto-header">
          <div className="manifesto-button">
            <TextSnippetRoundedIcon/>
            Our Revolutionary Manifesto
          </div>
          <h2 className="manifesto-title">What Makes Us Different</h2>
          <p className="manifesto-description">
            We're not just another platform. We're a <strong>movement</strong> with principles that challenge everything you know about freelancing.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="manifesto-cards">
          <div className="manifesto-card">
            <div className="card-icon">
              <div className="icon-background">
                <RocketLaunchRoundedIcon className='icon'/>
              </div>
            </div>
            <h3 className="card-title">Revolution, Not Evolution</h3>
            <p className="card-description">
              We're not improving the old system - we're building a completely new one from the ground up. <strong>Without Re-inventing the wheel!</strong>
            </p>
          </div>

          <div className="manifesto-card">
            <div className="card-icon">
              <div className="icon-background">
                <FavoriteRoundedIcon/>
              </div>
            </div>
            <h3 className="card-title">India First</h3>
            <p className="card-description">
              Built by Indians, for Indians. Every feature is designed with the Indian business owner in mind.
            </p>
          </div>

          <div className="manifesto-card">
            <div className="card-icon">
              <div className="icon-background">
                <LightbulbRoundedIcon/>
              </div>
            </div>
            <h3 className="card-title">AI First</h3>
            <p className="card-description">
              Our AI First approach doesn't just match people - It understands the business requirement context like an expert consultant.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsPageManifesto;
